// import React, { useEffect, useMemo, useState } from "react";
// import { API } from "../config/api";
// import { get } from "../lib/http";

// export default function CategoryBar({ value = "all", onChange = () => {} }) {
//   const [raw, setRaw] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // categories load
//   useEffect(() => {
//     let alive = true;
//     (async () => {
//       try {
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(API.category.category, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         if (!alive) return;
//         const list = Array.isArray(res?.categories) ? res.categories : [];
//         setRaw(list);
//       } catch (err) {
//         console.error("categoryList error:", err);
//         setRaw([]);
//       } finally {
//         setLoading(false);
//       }
//     })();
//     return () => {
//       alive = false;
//     };
//   }, []);

//   // normalize: string OR object → { id, name, value, icon? }
//   const cats = useMemo(() => {
//     const norm = raw.map((c) => {
//       if (typeof c === "string") {
//         return { id: c, name: c, value: c, icon: "" };
//       }
//       const id = c._id || c.id || c.slug || c.name || c.title;
//       const name = c.name || c.title || c.label || String(id || "Category");
//       const icon = c?.icon || ""; // backend se mila ho to use karenge
//       return { id, name, icon, value: c.slug || c.name || id };
//     });
//     // "All" ko sabse pehle with 📂
//     return [{ id: "all", name: "All", value: "all", icon: "📂" }, ...norm];
//   }, [raw]);

//   return (
//     <section className="bg-white border-b">
//       <div className="mx-auto max-w-7xl px-4 py-3 overflow-x-auto no-scrollbar">
//         <div className="flex gap-2">
//           {loading ? (
//             <div className="text-sm text-slate-500">Loading categories…</div>
//           ) : (
//             cats.map((c) => {
//               const active = String(value) === String(c.value);
//               return (
//                 <button
//                   key={c.id}
//                   onClick={() => onChange(c.value)}
//                   className={
//                     "flex items-center gap-2 whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-all duration-200 border shadow-sm " +
//                     (active
//                       ? "bg-[#FFC107] text-slate-700 border-[#FFC107] hover:bg-[#FFC107] hover:shadow-md"
//                       : "bg-white text-slate-700 border-slate-300 hover:bg-slate-50 hover:shadow-md")
//                   }
//                 >
//                   {c.icon ? <span className="text-lg">{c.icon}</span> : null}
//                   {c.name}
//                 </button>
//               );
//             })
//           )}
//         </div>
//       </div>
//     </section>
//   );
// }

import React, { useEffect, useMemo, useRef, useState } from "react";
import { API } from "../config/api";
import { get } from "../lib/http";

export default function CategoryBar({ value = "all", onChange = () => {} }) {
  const [raw, setRaw] = useState([]);
  const [loading, setLoading] = useState(true);

  // scroll shadow state
  const wrapRef = useRef(null);
  const [hasLeft, setHasLeft] = useState(false);
  const [hasRight, setHasRight] = useState(false);

  // categories load
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const res = await get(API.category.category, {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "application/json",
          },
        });
        if (!alive) return;
        const list = Array.isArray(res?.categories) ? res.categories : [];
        setRaw(list);
      } catch (err) {
        console.error("categoryList error:", err);
        setRaw([]);
      } finally {
        setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  // normalize: string OR object → { id, name, value, icon? }
  const cats = useMemo(() => {
    const norm = raw.map((c) => {
      if (typeof c === "string") {
        return { id: c, name: c, value: c, icon: "" };
      }
      const id = c._id || c.id || c.slug || c.name || c.title;
      const name = c.name || c.title || c.label || String(id || "Category");
      const icon = c?.icon || ""; // backend icon if any
      return { id, name, icon, value: c.slug || c.name || id };
    });
    return [{ id: "all", name: "All", value: "all", icon: "📂" }, ...norm];
  }, [raw]);

  // scroll shadows
  const updateShadows = () => {
    const el = wrapRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    setHasLeft(scrollLeft > 0);
    setHasRight(scrollLeft + clientWidth < scrollWidth - 1);
  };
  useEffect(() => {
    updateShadows();
    const el = wrapRef.current;
    if (!el) return;
    const on = () => updateShadows();
    el.addEventListener("scroll", on, { passive: true });
    window.addEventListener("resize", on);
    return () => {
      el.removeEventListener("scroll", on);
      window.removeEventListener("resize", on);
    };
  }, [loading, cats.length]);

  // keyboard navigation
  const onKeyDown = (e) => {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key)) return;
    e.preventDefault();
    const idx = cats.findIndex((c) => String(c.value) === String(value));
    if (idx === -1) return;
    let next = idx;
    if (e.key === "ArrowLeft") next = Math.max(0, idx - 1);
    if (e.key === "ArrowRight") next = Math.min(cats.length - 1, idx + 1);
    if (e.key === "Home") next = 0;
    if (e.key === "End") next = cats.length - 1;
    const nextVal = cats[next]?.value;
    if (nextVal != null) {
      onChange(nextVal);
      // scroll into view
      const btn = document.getElementById(`cat-${String(nextVal)}`);
      btn?.scrollIntoView({ inline: "center", behavior: "smooth", block: "nearest" });
    }
  };

  // button UI
  const Chip = ({ active, icon, children, id, onClick }) => (
    <button
      id={id}
      aria-pressed={active}
      onClick={onClick}
      className={
        "group relative flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 md:px-4 py-1.5 md:py-2 text-xs sm:text-sm font-semibold transition-all " +
        (active
          ? "text-slate-900 bg-gradient-to-r from-amber-300 to-amber-400 shadow-[0_6px_14px_rgba(251,191,36,0.35)] ring-1 ring-amber-300"
          : "text-slate-700 bg-white hover:bg-slate-50 border border-slate-200")
      }
    >
      {active && (
        <span className="absolute -inset-px rounded-full bg-amber-400/0 group-hover:bg-amber-400/10 transition-colors" />
      )}
      {icon ? <span className="text-base">{icon}</span> : null}
      <span className="relative">{children}</span>
    </button>
  );

  return (
    <section className="sticky top-0 z-30 border-b bg-white/90 font-sans backdrop-blur">
      <div className="mx-auto w-full md:w-[85%] max-w-7xl px-3 py-2 sm:px-4 md:px-0">
        <div className="relative">
          {/* left shadow */}
          <div
            className={`pointer-events-none absolute left-0 top-0 h-full w-6 bg-gradient-to-r from-white to-transparent transition-opacity ${hasLeft ? "opacity-100" : "opacity-0"}`}
          />
          {/* right shadow */}
          <div
            className={`pointer-events-none absolute right-0 top-0 h-full w-6 bg-gradient-to-l from-white to-transparent transition-opacity ${hasRight ? "opacity-100" : "opacity-0"}`}
          />

          <div
            ref={wrapRef}
            className="flex gap-2 overflow-x-auto no-scrollbar scroll-smooth"
            role="tablist"
            aria-label="Categories"
            tabIndex={0}
            onKeyDown={onKeyDown}
          >
            {loading ? (
              <SkeletonRow />
            ) : (
              cats.map((c) => {
                const active = String(value) === String(c.value);
                return (
                  <Chip
                    key={c.id}
                    id={`cat-${String(c.value)}`}
                    active={active}
                    icon={c.icon}
                    onClick={() => onChange(c.value)}
                  >
                    {c.name}
                  </Chip>
                );
              })
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ------------ Pretty shimmer while loading ------------ */
function SkeletonRow() {
  const items = Array.from({ length: 7 });
  return (
    <div className="flex gap-2 w-full">
      {items.map((_, i) => (
        <div
          key={i}
          className="h-8 md:h-9 w-20 md:w-24 rounded-full bg-slate-100 overflow-hidden relative"
        >
          <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.3s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
        </div>
      ))}
      <style>{`
        @keyframes shimmer {
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}
